import styled from "styled-components";
import { COLORS } from "../../../../../../../../styles/constants.style";

export const ProgramClosureDetailsWrapper = styled.div`
  .status-container {
    padding: 24px 16px;
    .status-label {
      color: ${COLORS.cirrus_black10};
    }
  }

  .closure-header {
    background-color: ${COLORS.primary_light_blue2};
  }

  .form-container {
    padding-left: 16px;
  }

  .change-status-form {
    padding-bottom: 16px;
  }

  .closed-date {
    padding-bottom: 24px;
  }

  .landed-information{
    margin-top: 16px;
  }

  .employee-tab-panel,
  .general-tab-panel {
    padding-bottom: 8px;
    .grid-container {
      padding-bottom: 16px;
    }
  }

  .employee-tab-panel {
    .grid-size-medium:nth-of-type(n + 4) {
      margin-top: 40px;
    }
  }
`;
